import { API_ENDPOINTS } from "../api-endpoints";
import { HttpClient } from "../http-client";
import { InterfaceReward } from "../types/types";

export const reward = {
  GetAllReward: (options?: any) => {
    return HttpClient.get<InterfaceReward>(
      API_ENDPOINTS.GET_ALL_REWARDS,
      options
    );
  },
};
